import * as React from 'react';
import {Input as SemanticInput} from "semantic-ui-react";
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";

interface NumberInputProps extends IVirtualizedTableCellComponentProps {
}

interface NumberInputState {
    value: number;
}

export default class NumberInput extends React.Component<NumberInputProps, NumberInputState> {
    constructor(props: NumberInputProps) {
        super(props);

        this.state = {
            value: 0
        };
    }

    componentDidMount() {
        this.setState({value: this.props.value});
    }

    componentDidUpdate(prevProps: NumberInputProps, prevState: NumberInputState) {
        if (this.props.value !== prevProps.value && this.state.value !== this.props.value)
            this.setState({value: this.props.value});
    }

    private saveChange = () => {
        if (!Number.isNaN(this.state.value) && this.props.value !== this.state.value) {
            this.props.onChange(this.state.value);
        } else {
            this.setState({value: this.props.value});
        }
    }

    public render() {
        return (
            <SemanticInput
                type="number"
                value={this.state.value ? this.state.value : 0}
                fluid={true}
                onChange={(e) => {
                    this.setState({value: e.currentTarget.valueAsNumber});
                }}
                disabled={this.props.readOnly}
                onBlur={this.saveChange}
            />
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/NumberInput.tsx